import http from '../../../libs/http';
import * as types from './config-mutation-types';

/**
 * 获取系统配置（优惠价格等配置）
 */
export const getSysConfig = ({ commit, state }) => new Promise((resolve, reject) => {
  if (state.sys_config) {
    resolve(state.sys_config);
  } else {
    http.post('/sys/sys_config_get')
      .then((data) => {
        commit(types.SET_CONFIG, data);
        resolve(data);
      }).catch(() => {
        reject();
      });
  }
});



// WEBPACK FOOTER //
// ./src/store/modules/config/config-actions.js